import { Col, Row } from 'antd';
import React from 'react';

import LeiLoginlessFooter from 'components/molecules/Lei/zadostLeiLoginless/LeiLoginlessFooter';
import LeiLoginlessMenu from 'components/molecules/Lei/zadostLeiLoginless/LeiLoginlessMenu';

const Onas: React.FC = () => {
    return (
        <>
            <LeiLoginlessMenu />
            <Row
                id="Onas"
                style={{
                    paddingTop: 24,
                    paddingBottom: 24,
                    display: 'block',
                    background: 'white'
                }}
            >
                <div
                    style={{
                        margin: '0 auto',
                        maxWidth: 1200
                    }}
                >
                    <Col
                        style={{
                            display: 'block',
                            paddingLeft: 20,
                            maxWidth: 800,
                            background: 'white'
                        }}
                    >
                        <h1
                            style={{
                                color: '#007777'
                            }}
                        >
                            Co je CDCP
                        </h1>
                        <p>
                            <strong>
                                Centrální depozitář cenných papírů, a.s. (dále jen „CDCP“) je subjekt autorizovaný
                                Českou národní bankou podle evropského nařízení o činnosti centrálních depozitářů
                                (CSDR).
                            </strong>
                        </p>
                        <h2>Vedení evidencí a vypořádání</h2>
                        <p>
                            Základní činnost CDCP spočívá ve vedení centrální evidence zaknihovaných cenných papírů a
                            vypořádání obchodů s investičními nástroji.
                        </p>
                        <p>
                            V centrální evidenci jsou evidovány zaknihované cenné papíry vydané v České republice.
                            Centrální evidence je evidencí dvoustupňovou a tvoří ji evidence vedená CDCP a evidence
                            navazující, kterou vedou oprávněné subjekty, zejména pak banky, obchodníci s cennými papíry,
                            investiční společnost apod.
                        </p>
                        <p>
                            Cenné papíry jsou evidovány na dvou typech majetkových účtů. Prvním typem je účet vlastníka,
                            jehož majitelem je vlastník cenných papírů. Druhým typem je účet zákazníků, jehož majitelem
                            je účastník CDCP, který však není vlastníkem cenných papírů evidovaných na tomto účtu, pouze
                            je převzal do správy od jejich vlastníků. Zatímco v centrální evidenci vedené CDCP mohou být
                            zřizovány účty vlastníků i zákazníků, v navazující evidenci pouze účty vlastníků.
                        </p>
                        <p>
                            CDCP vede též samostatnou evidenci cenných papírů, ve které jsou evidovány zejména
                            zahraniční cenné papíry, listinné cenné papíry, sběrné dluhopisy, investiční nástroje
                            derivátového typu. CDCP rovněž technicky podporuje vedení samostatné evidence Ministerstva
                            financí ČR.
                        </p>
                        <p>
                            CDCP zajišťuje finanční <a href="https://www.cdcp.cz/ucastnici/vyporadani/">vypořádání</a>{' '}
                            burzovních i mimoburzovních obchodů s cennými papíry uzavřených na{' '}
                            <a href="http://www.pse.cz/">Burze cenných papírů Praha</a>.
                        </p>
                        <p>
                            CDCP funguje na účastnickém principu a služby CDCP spojené s vedením evidence cenných papírů
                            a vypořádáním obchodů jsou poskytovány pouze prostřednictvím jeho{' '}
                            <a href="https://www.cdcp.cz/ucastnici/seznam-ucastniku/">účastníků</a>.
                        </p>
                        <h2>Další činnosti</h2>
                        <p>
                            CDCP dále přiděluje investičním nástrojům identifikační označení podle mezinárodního systému
                            číslování (ISIN) a plní také úlohu lokálního operátora (LOU) a přiděluje právnickým osobám
                            tzv.{' '}
                            <a href="https://www.cdcp.cz/lei/obecne-informace-o-lei/">Legal Entity Identifier (LEI)</a>,
                            který unikátně identifikuje právnické osoby, a to celosvětově.
                        </p>
                        <p>
                            Emitentům, kteří mají zájem o zaknihování, poskytuje CDCP informace a podporu v průběhu
                            celého procesu zaknihování.
                        </p>
                        <p>
                            Účastníci, uživatelé z oblasti státní správy, emitenti, administrátoři, notáři a další mohou
                            na základě registrace získávat informace prostřednictvím zabezpečené komunikace za využití{' '}
                            <a href="https://www.cdcp.cz/mujdepozitar">informačního portálu Můj depozitář</a> (dříve
                            ISB).
                        </p>
                        <p>
                            Vedle výše uvedených činností poskytuje CDCP svým účastníkům, emitentům cenných papírů a
                            ostatním subjektům kapitálového trhu další služby, jako je např. správa zahraničních cenných
                            papírů registrovaných na účtech CDCP v mezinárodních depozitářích Euroclear a{' '}
                            <a href="http://www.clearstream.com/" target="_blank" rel="noopener noreferrer">
                                Clearstream
                            </a>
                            , vyplácení výnosů z cenných papírů či zajištění půjčování tuzemských i zahraničních cenných
                            papírů.
                        </p>
                        <h2>Historie</h2>
                        <p>
                            CDCP jako instituce kapitálového trhu funguje již od roku 1993. V roce 1993 byl založen
                            Burzovní registr cenných papírů, který se v roce 1996 transformoval na akciovou společnost
                            UNIVYC. V roce 2010 společnost převzala evidence Střediska cenných papírů a zahájila činnost
                            centrálního depozitáře pod novým názvem Centrální depozitář cenných papírů, a. s. V roce
                            2018 byl Centrální depozitář licencován podle evropského nařízení o činnosti centrálních
                            depozitářů (CSDR). Centrální depozitář je členem{' '}
                            <a href="http://www.ecsda.eu/" target="_blank" rel="noopener noreferrer">
                                Evropské asociace centrálních depozitářů cenných papírů (ECSDA)
                            </a>
                            .
                        </p>
                        <h2>Skupina PX</h2>
                        <p>
                            CDCP je stoprocentní dceřinou společností{' '}
                            <a href="http://www.pse.cz/">Burzy cenných papírů Praha</a>.
                        </p>
                        <p>
                            CDCP je součástí skupiny PX, jejímiž nejvýznamnějšími členy jsou kromě CDCP také{' '}
                            <a href="http://www.pse.cz/">Burza cenných papírů Praha</a>. Burza cenných papírů Praha je
                            největším a nejstarším organizátorem trhu s cennými papíry v České republice a obchodování
                            na ní probíhá prostřednictvím licencovaných obchodníků, kteří jsou zároveň členy burzy. Se
                            skupinou PX dále úzce spolupracuje společnost{' '}
                            <a href="http://www.pxe.cz/">POWER EXCHANGE CENTRAL EUROPE</a> (PXE), která představuje
                            obchodní platformu pro obchodování s elektřinou a zemním plynem.
                        </p>
                        <hr
                            style={{
                                margin: '40px 0',
                                border: 'none',
                                borderTop: '1px solid #ccc'
                            }}
                        />
                        <h2>
                            <em>Výbory CDCP</em>
                        </h2>
                        <p>
                            <em>
                                CDCP v souladu s evropským nařízením o činnosti centrálních depozitářů (CSDR) zřídil
                                tyto poradní výbory, které poskytují konzultace a doporučení představenstvu:
                            </em>
                        </p>
                        <ul
                            style={{
                                paddingLeft: 20
                            }}
                        >
                            <li>
                                <em>
                                    Výbor pro rizika – ohledně současné i budoucí celkové tolerance centrálního
                                    depozitáře vůči rizikům a ohledně jeho strategie v oblasti rizik
                                </em>
                            </li>
                            <li>
                                <em>Výbor pro audit – ohledně výkonu funkce interního auditu centrálního depozitáře</em>
                            </li>
                            <li>
                                <em>Výbor pro odměňování – ohledně zásad odměňování centrálního depozitáře</em>
                            </li>
                        </ul>{' '}
                    </Col>
                </div>
            </Row>
            <LeiLoginlessFooter />
        </>
    );
};

export default Onas;
